import React from 'react';
import pb from '../../lib/pocketbase';
import './Footer.css';

const Footer = ({ setCurrentPage, setShowTour, setTourStep, installPWA, canInstall, agencySettings }) => {
    const companyName = agencySettings?.company_name || "L'Univers Diag";
    const description = agencySettings?.description_short || "Expertise en ingénierie électronique et diagnostic automobile de pointe à Toulouse. Reprogrammation E85, double de clés et solutions de mobilité haute performance.";
    
    const logoUrl = agencySettings ? (
        agencySettings.logo_dark ? pb.files.getUrl(agencySettings, agencySettings.logo_dark) : '/logo.png'
    ) : '/logo.png';

    const socials = agencySettings?.socials ? (typeof agencySettings.socials === 'string' ? JSON.parse(agencySettings.socials) : agencySettings.socials) : {};

    return (
        <footer className="footer-premium">
            <div className="footer-content">
                <div className="footer-brand-section">
                    <div className="footer-logo-container">
                        <img src={logoUrl} alt={companyName} className="footer-logo" />
                        <span className="footer-brand-name">{companyName.toUpperCase()}</span>
                    </div>
                    <p className="footer-description">
                        {description}
                    </p>
                    <div className="footer-socials">
                        {Object.entries(socials).map(([platform, url]) => {
                            if (!url) return null;
                            const p = platform.toLowerCase();
                            return (
                                <a key={p} href={url} target="_blank" rel="noopener noreferrer" className={`social-link sl-${p}`} aria-label={p}>
                                    {p === 'instagram' && (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>
                                    )}
                                    {p === 'facebook' && (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                                    )}
                                    {p === 'linkedin' && (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>
                                    )}
                                    {p === 'tiktok' && (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 12a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path><path d="M15 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"></path><path d="M15 2v4a3 3 0 0 1-3 3H9"></path><path d="M15 2v2a4 4 0 0 0 4 4"></path></svg>
                                    )}
                                    {!['instagram', 'facebook', 'linkedin', 'tiktok'].includes(p) && (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                                    )}
                                </a>
                            );
                        })}
                    </div>
                    {canInstall && (
                        <button className="pwa-install-btn gold" onClick={installPWA}>
                            📲 Installer l'application
                        </button>
                    )}
                </div>

                <div className="footer-links-grid">
                    <div className="footer-column">
                        <h4>Expertises</h4>
                        <ul>
                            <li><button onClick={() => setCurrentPage('cles')}>Double de Clés</button></li>
                            <li><button onClick={() => setCurrentPage('ethanol')}>Conversion Éthanol</button></li>
                            <li><button onClick={() => setCurrentPage('diagnostic')}>Diagnostic Profond</button></li>
                            <li><button onClick={() => setCurrentPage('moteur')}>Ingénierie Moteur</button></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4>Atelier</h4>
                        <ul>
                            <li><button onClick={() => setCurrentPage('accueil')}>Accueil</button></li>
                            <li><button onClick={() => setCurrentPage('booking')}>Prendre RDV</button></li>
                            <li><button onClick={() => setCurrentPage('account')}>Mon Espace</button></li>
                            <li><button onClick={() => {
                                setCurrentPage('accueil');
                                setShowTour(true);
                                setTourStep(0);
                                try {
                                    localStorage.removeItem('universdiag_tour_done');
                                } catch (e) { /* ignore */ }
                            }}>Guide Interactif</button></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h4>Contact</h4>
                        <div className="footer-contact-info">
                            <p className="contact-item">📍 {agencySettings?.address_office || '123 Avenue de Grande Bretagne, Toulouse'}</p>
                            <p className="contact-item">📞 {agencySettings?.phone_public || '06 00 00 00 00'}</p>
                            <p className="contact-item">✉️ {agencySettings?.email_public || 'contact@luniversdiag.fr'}</p>
                            <div className="footer-hours">
                                {(() => {
                                    // 1. Status Check
                                    let statusBadge = null;
                                    if (agencySettings?.busy_mode_active || agencySettings?.closure_banner_active) {
                                        statusBadge = <span className="status-badge closed">⚠️ INDISPONIBLE</span>;
                                    } else {
                                        try {
                                            const now = new Date();
                                            const dayNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                                            const h = agencySettings?.opening_hours ? (typeof agencySettings.opening_hours === 'string' ? JSON.parse(agencySettings.opening_hours) : agencySettings.opening_hours) : null;
                                            const daySet = h ? h[dayNames[now.getDay()]] : null;

                                            if (daySet && daySet.open && daySet.start && daySet.end) {
                                                const [startH, startM] = daySet.start.split(':').map(Number);
                                                const [endH, endM] = daySet.end.split(':').map(Number);
                                                const currentTotal = now.getHours() * 60 + now.getMinutes();
                                                const startTotal = startH * 60 + startM;
                                                const endTotal = endH * 60 + endM;

                                                if (currentTotal >= startTotal && currentTotal < endTotal) {
                                                    statusBadge = <span className="status-badge open">● OUVERT</span>;
                                                } else {
                                                    statusBadge = <span className="status-badge closed">● FERMÉ</span>;
                                                }
                                            } else {
                                                statusBadge = <span className="status-badge closed">● FERMÉ</span>;
                                            }
                                        } catch (e) {
                                            statusBadge = <span className="status-badge closed">● FERMÉ</span>;
                                        }
                                    }

                                    if (!agencySettings?.opening_hours) return (
                                        <>
                                            {statusBadge}
                                            <span>Lun - Ven : 09h00 - 18h30</span>
                                            <span>Sam : 09h00 - 12h30</span>
                                        </>
                                    );
                                    
                                    const h = typeof agencySettings.opening_hours === 'string' ? JSON.parse(agencySettings.opening_hours) : agencySettings.opening_hours;
                                    const mon = h.monday || { start: '09:00', end: '18:30', open: true };
                                    const sat = h.saturday || { start: '09:00', end: '12:30', open: true };
                                    
                                    return (
                                        <>
                                            {statusBadge}
                                            <span>Lun - Ven : {mon.open ? `${mon.start.replace(':', 'h')} - ${mon.end.replace(':', 'h')}` : 'Fermé'}</span>
                                            {sat.open && <span>Sam : {sat.start.replace(':', 'h')} - {sat.end.replace(':', 'h')}</span>}
                                        </>
                                    );
                                })()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <div className="footer-bottom-content">
                    <p>© {new Date().getFullYear()} {companyName}. Tous droits réservés.</p>
                    <div className="footer-legal-links">
                        <a href="/mentions-legales">Mentions Légales</a>
                        <a href="/cgv">CGV</a>
                        <a href="/confidentialite">Confidentialité</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
